import ApplicationController from './application_controller';
import log from '../lib/logger';

export default class extends ApplicationController {
  static targets = ['radarChart'];

  connect() {
    // Initialize the radar chart when the controller connects
    if (this.hasRadarChartTarget) {
      this.initializeRadarChart();
    }
  }

  radarChartTargetConnected() {
    // This will be called when the radar chart element is added to the DOM
    this.initializeRadarChart();
  }

  initializeRadarChart() {
    // Import and initialize the billing health module
    import('../pages/billing_health')
      .then((module) => {
        const billingHealth = module.default;
        if (billingHealth !== undefined) {
          billingHealth();
        }
      })
      .catch((error) => {
        log.error('Error loading billing health module:', error);
      });
  }
}
